import React, { useEffect } from 'react';
import { Helmet } from "react-helmet";
import { connect } from 'react-redux';
import { useParams } from "react-router";

import { StarIcon, ClockIcon } from '@heroicons/react/20/solid'

function Partner({
    contactInList,
    profile,
}) {
    let { slug } = useParams();
    let partner = {
        name: 'UpStox',
        status: 'Buddy Master',
        image:
            'https://bizbehindsports.com/wp-content/uploads/2021/07/51003444_2378086569081776_6714125917737713664_n.jpg',
        bio: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur? Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.',
        quote: 'Sed ut perspiciatis unde omnis iste natus error sit.',
        since: 2019,
        certified: 2020,
    };
    let partnerTeam = [
        {
            name: 'Gus Fring',
            image:
                'https://i.ytimg.com/vi/JXMIpHDgb2A/maxresdefault.jpg',
            profession: 'Junior Accountant',
            linkedIn: 'https://mt.linkedin.com/',
        },
        {
            name: 'Skyler White',
            image:
                'https://goat.com.au/wp-content/uploads/2018/07/skyler-white.jpg',
            profession: 'Senior Accountant',
            linkedIn: 'https://mt.linkedin.com/',
        },
        {
            name: 'Walter Hartwell White',
            image:
                'https://es.web.img2.acsta.net/newsv7/20/08/12/11/34/4800141.jpg',
            profession: 'Payroll Administrator',
            linkedIn: 'https://mt.linkedin.com/',
        },
    ];
    let integrationsArr = [
        {
            company: 'Xero',
            softwareType: 'Accounting Software',
            image: 'https://lawyerist.com/wp-content/uploads/2017/05/Xero-Logo.png',
        },
        {
            company: 'Deputy',
            softwareType: 'Time Clocking Software',
            image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT2FIw5ZymK8EZm7zbwv_uWtA-qqJBdjGxT8A&usqp=CAU',
        },
    ];
    let findUs = [
        {
            country: 'Malta',
            address: '190 Triq is-Sewqan, Zabbar, ZBR 1615',
            mobile: '+356 2152 3343',
        },
        {
            country: 'United Kingdom',
            address: 'Northcliffe Park/Northcliffe Crown Green Bowls Club, Springswood Avenue, Shipley, Bradford, BD18 3DH',
            mobile: '+44 141 496 0701',
        },
    ];
    useEffect(() => {
        if (profile && profile.email) {
            contactInList({
                email: profile.email,
            })
        }
    }, [profile && profile.email]);
    return (
        <React.Fragment>
            <Helmet>
                <title>Partner Details | Buddy</title>
                <meta name="description" content="" />
                <link rel="canonical" href={`https://www.buddy.hr/partner/details`} />
            </Helmet>
            <main className="lg:mb-24 mb-8 sm:mb-16 md:mb-20 xl:mt-2">
                {/* Partner Section*/}
                <section className="mx-auto max-w-screen-lg mt-10 mb-16 px-4 lg:px-11 xl:max-w-screen-xl">
                    <div className="lg:grid lg:grid-cols-12">
                        <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-2 lg:text-left lg:flex lg:items-center">
                            <div>                      
                                <h1 className="mt-4 text-4xl tracking-tight font-extrabold text-white sm:mt-5 sm:leading-none sm:text-6xl lg:mt-6 lg:text-5xl xl:text-6xl">
                                    {partner.name}
                                </h1>
                                <p className=" text-base text-gray-300 sm:text-xl lg:text-lg xl:text-xl">
                                    Accountant
                                </p>
                            </div>
                        </div>
                    </div>
                        
                    <div className="lg:flex mt-10 xl:max-h-[44rem] lg:max-h-[27rem]">
                        <article className="mx-auto mb-14 max-w-lg lg:block hidden rounded-2xl overflow-hidden bg-gray-50 drop-shadow-lg text-left lg:mx-0 lg:max-w-md xl:max-w-xs lg:mb-0">
                            <img className="object-cover aspect-[16/10] w-full" src={partner.image} />

                            <div className="flex mx-auto w-64 lg:w-52 xl:w-72 bg-gray-50 my-8 text-left h-14 lg:h-12 xl:h-24 xl:my-4">
                                <div className="flex-none object-cover aspect-[1/1] bg-orange-500 rounded-lg xl:rounded-2xl xl:m-3">
                                    <StarIcon className="m-auto w-fit p-2 text-white" aria-hidden="true" />
                                </div>
                                <div className="px-2 xl:py-5">
                                    <h3 className="md:text-md lg:text-sm xl:text-lg tracking-tight text-gray-400">Buddy Advisor Status</h3>
                                    <h3 className="md:text-xl lg:text-lg xl:text-2xl tracking-tight text-gray-900 font-semibold">{partner.status}</h3>
                                </div>
                            </div>
                            
                            <div className="flex mx-auto w-64 lg:w-52 xl:w-72 bg-gray-50 my-8 text-left h-14 lg:h-12 xl:h-24 xl:my-4">
                                <div className="rounded-lg xl:rounded-2xl flex-none object-cover aspect-[1/1] bg-orange-500 xl:m-3">
                                    <ClockIcon className="m-auto w-fit p-2 text-white" aria-hidden="true" />
                                </div>
                                <div className="px-2 xl:py-5">
                                    <h3 className="md:text-md lg:text-sm xl:text-lg tracking-tight text-gray-400">Using Buddy Since</h3>
                                    <h3 className="md:text-xl lg:text-lg xl:text-2xl tracking-tight text-gray-900 font-semibold">{partner.since}</h3>
                                </div>
                            </div>

                            <div className="flex mx-auto w-64 lg:w-52 xl:w-72 bg-gray-50 my-8 text-left h-14 lg:h-12 xl:h-24 xl:my-4">
                                <div className="rounded-lg xl:rounded-2xl flex-none object-cover aspect-[1/1] bg-orange-500 xl:m-3">
                                    <StarIcon className="m-auto w-fit p-2 text-white" aria-hidden="true" />
                                </div>
                                <div className="px-2 xl:py-5">
                                    <h3 className="md:text-md lg:text-sm xl:text-lg tracking-tight text-gray-400">Buddy Certified Since</h3>
                                    <h3 className="md:text-xl lg:text-lg xl:text-2xl tracking-tight text-gray-900 font-semibold">{partner.certified}</h3>
                                </div>
                            </div>
                        </article>

                        <article className='mx-auto mb-4 max-w-lg rounded-2xl overflow-hidden lg:hidden bg-gray-50 drop-shadow-lg text-left lg:mx-0 lg:max-w-md xl:max-w-xs lg:mb-0"'>
                            <div className="flex text-left h-32 overflow-hidden">
                                <img className="object-cover aspect-[1/1]" src={partner.image}/>

                                <div>
                                    <div className="flex mx-2 w-64 my-2 text-left h-8">
                                        <div className="flex-none object-cover aspect-[1/1] bg-orange-500 rounded-lg">
                                            <StarIcon className="m-auto w-fit p-1.5 text-white" aria-hidden="true" />
                                        </div>
                                        <div className="px-2 my-auto">
                                            <h3 className="text-lg tracking-tight text-gray-900 font-semibold">{partner.status}</h3>
                                        </div>
                                    </div>

                                    <div className="flex mx-2 w-64 my-2 text-left h-8">
                                        <div className="flex-none object-cover aspect-[1/1] bg-orange-500 rounded-lg">
                                            <ClockIcon className="m-auto w-fit p-1.5 text-white" aria-hidden="true" />
                                        </div>
                                        <div className="px-2 my-auto">
                                            <h3 className="text-lg tracking-tight text-gray-900 font-semibold">Using Buddy since {partner.since}</h3>
                                        </div>
                                    </div>

                                    <div className="flex mx-2 w-64 my-2 text-left h-8">
                                        <div className="flex-none object-cover aspect-[1/1] bg-orange-500 rounded-lg">
                                            <StarIcon className="m-auto w-fit p-1.5 text-white" aria-hidden="true" />
                                        </div>
                                        <div className="px-2 my-auto">
                                            <h3 className="text-lg tracking-tight text-gray-900 font-semibold">Certified since {partner.certified}</h3>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </article>

                        <article className="bg-white mx-auto mb-14 py-8 xl:py-16 flex-auto max-w-lg rounded-2xl overflow-y-auto bg-gray-50 drop-shadow-lg text-left lg:mx-0 lg:max-w-2xl xl:max-w-3xl lg:mb-0 lg:ml-4 xl:ml-14">
                            <h3 className="mx-8 xl:mx-12 text-xl xl:text-3xl tracking-tight text-gray-900 font-semibold">Partner</h3>
                            <p className="mx-8 xl:mx-12 text-lg xl:text-xl tracking-tight text-gray-400">{partner.bio}</p>
                        </article>
                    </div>
                </section>

                {/* Team Section */}
                <section className="flex bg-white py-10 px-4 lg:px-11">
                    <div className="mx-auto max-w-screen-lg mb-10 xl:max-w-screen-xl">
                        <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:text-left lg:flex lg:items-center lg:mx-0">
                            <div>                      
                                <h1 className="mt-4 text-4xl tracking-tight font-extrabold sm:mt-5 sm:leading-none sm:text-6xl lg:mt-6 lg:text-5xl xl:text-6xl">
                                    The Team
                                </h1>
                                <p className="text-base text-gray-400 sm:text-xl lg:text-lg xl:text-xl">
                                    {partner.quote}
                                </p>
                            </div>
                        </div>

                        <ul role="list" class="mx-auto mt-20 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3">
                            {partnerTeam.map((partnerTeam) => (
                                <li>
                                    <img class="aspect-[3/2] w-full rounded-2xl object-cover" src={partnerTeam.image} alt="" />
                                    <h3 class="mt-6 text-lg font-semibold leading-8 tracking-tight text-gray-900">{partnerTeam.name}</h3>
                                    <p class="inline-block text-base leading-7 text-gray-400">{partnerTeam.profession}</p>
                                    <li class="inline-block float-right">
                                        <a href={partnerTeam.linkedIn} class="text-gray-400 hover:text-gray-500">
                                        <span class="sr-only">LinkedIn</span>
                                        <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                                            <path fill-rule="evenodd" d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z" clip-rule="evenodd" />
                                        </svg>
                                        </a>
                                    </li>
                                </li>
                            ))}
                        </ul>
                    </div>
                </section>

                {/* Integrations Section */}
                <section className="flex bg-orange-600 py-10 px-4 lg:px-11">
                    <div className="mx-auto max-w-screen-lg mb-10 xl:max-w-screen-xl">
                        <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl lg:items-center">
                            <div>                      
                                <h1 className="text-white mt-4 text-4xl tracking-tight font-extrabold sm:mt-5 sm:leading-none sm:text-6xl lg:mt-6 lg:text-5xl xl:text-6xl">
                                    Integrations
                                </h1>
                                <p className="text-base text-orange-100 sm:text-xl lg:text-lg xl:text-xl">
                                    Applications used by the company connected via Buddy
                                </p>
                            </div>
                        </div>
                        
                        <div className="lg:flex m-auto w-fit">
                            {integrationsArr.map((integration) => (
                                <div className="rounded-2xl flex bg-gray-50 mt-8 mx-4 text-left h-24 w-80 overflow-hidden">
                                    <img className="object-cover aspect-[1/1]" src={integration.image}/>
                                    <div className="p-5">
                                        <h3 className="text-lg tracking-tight text-gray-400">{integration.softwareType}</h3>
                                        <h3 className="text-2xl tracking-tight text-gray-900 font-semibold">{integration.company}</h3>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Find Us Section */}
                <section className="flex-auto bg-white py-10 px-4 lg:px-11">
                    <div className="mx-auto max-w-screen-lg mb-10 xl:max-w-screen-xl">
                        <div className="mb-16 lg:px-0 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:text-left lg:flex lg:items-center lg:mx-0">
                            <div>                      
                                <h1 className="mt-4 text-4xl tracking-tight font-extrabold sm:mt-5 sm:leading-none sm:text-6xl lg:mt-6 lg:text-5xl xl:text-6xl">
                                    Find Us
                                </h1>
                                <p className="text-base text-gray-400 sm:text-xl lg:text-lg xl:text-xl">
                                    {partner.quote}
                                </p>
                            </div>
                        </div>

                        <div className="flex-auto">
                            {findUs.map((findUs) => (
                                <div className="mt-2">
                                    <h3 className="text-3xl tracking-tight text-gray-900">{findUs.country}</h3>
                                    <h3 className="text-lg tracking-tight text-gray-400">{findUs.address}</h3>
                                    <h3 className="text-lg tracking-tight text-gray-400">{findUs.mobile}</h3>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </main>
        </React.Fragment>
    );
}

export default connect(
)(Partner)